var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Papa from 'papaparse';
function validateCsvFile(file) {
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB
    const allowedExtensions = ['csv'];
    // Check file size
    if (file.size > maxSizeInBytes) {
        return false;
    }
    // Check file extension
    const fileExtension = file.name.split('.').pop();
    if (!allowedExtensions.includes(fileExtension)) {
        return false;
    }
    return true;
}
function parseCSV(file) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            Papa.parse(file, {
                header: true,
                // dynamicTyping: true,
                complete: (results) => {
                    resolve(Object.assign(Object.assign({}, results), { fileName: file.name }));
                },
                error: (error) => {
                    console.error(error);
                    reject(error);
                }
            });
        });
    });
}
export { parseCSV, validateCsvFile };
